import { put, call, fork, takeLatest, all } from 'redux-saga/effects';

import * as routes from 'app/routes';
import { info, error } from 'notifications/actions';

import * as types from './types';
import * as api from './api';
import * as actions from './actions';

export function* checkoutPurchase(action) {
  const { purchaseId, cardId, onComplete, message } = action.payload;
  try {
    yield put(actions.checkoutPending(purchaseId));
    const resp = yield call(api.checkout, purchaseId, cardId);
    yield put(actions.checkoutSucceeded(resp));
    yield fork(allocateLineItems, resp.data.line_items);
    yield put(routes.purchase(purchaseId));
    yield put(info('general', message || 'Your payment was successful.'));

    if (onComplete) {
      yield call(onComplete);
    }
  }
  catch (err) {
    const resp = err.response;
    yield put(actions.checkoutFailed(purchaseId));
    yield put(error('payPurchase', resp.data.detail));
  }
}

export function* allocateLineItems(items) {
  try {
    yield put(actions.allocationPending());
    yield all(
      items
        .filter(item => item.item_type === 'plan' || item.item_type === 'bypassed_plan')
        .map(item => item.item_type === 'plan' ?
          call(api.allocate_sprint, item.plan, item.subscription) :
          call(api.allocate_bypassed, item.bypassed_plan, item.bypassed_subscription))
    );
    yield put(actions.allocationSucceeded());
  }
  catch (err) {
    yield put(actions.allocationFailed());
  }
}

export function* watchPayPurchase() {
  yield takeLatest(types.CHECKOUT, checkoutPurchase);
}
